
import { useEffect, useState, useRef } from 'react';
import Alert from '@mui/material/Alert';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';

// @mui
import {
  Tooltip,
  Badge,
  // Grid,
  // Card,
  Table,
  // Stack,
  Paper,
  // Avatar,
  Button,
  // Popover,
  // Checkbox,
  TableRow,
  // MenuItem,
  TableBody,
  TableCell,
  // Container,
  // Typography,
  // IconButton,
  TableContainer,
  // TablePagination,
  TextField,
  TableHead,
  TableFooter,
} from '@mui/material';
import { id } from 'date-fns/locale';
import Swal from 'sweetalert2';
import AlertPage from "../pages/AlertPage";
import "./InsertAdvancessPopup.css";

// components
import Iconify from '../components/iconify';
import { variables } from '../Variables';
import { DailyAccountUpdateData } from '../model/DailyAccountModel';
import { InsertDailyAdvance } from '../components/api/DailyAccountApiService';

function InsertAdvancessPopup(props) {
  const [dailyAdv, setdailyAdv] = useState(props.dailyAdv);
  const navigate = useNavigate();
  const current = new Date(props.date);
  // const [date, setdate] = useState(props.date);
  const datee = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;


  const [trid, settrid] = useState(props.trid);
  // const [OPCash, setOPCash] = useState(props.oPCash);
  // const [TotaBillSales, setTotaBillSales] = useState(0);
  // const [TotaNonBillSales, setTotaNonBillSales] = useState(0);  
  // const [CreditIN, setCreditIN] = useState(0);
  const [Advance, setAdvance] = useState(0);
  // const [CashIn, setCashIn] = useState(0);
  // const [PurchaseCashPayment, setPurchaseCashPayment] = useState(0);
  // const [GPay, setGPay] = useState(0);
  // const [CardPay, setCardPay] = useState(0);
  // const [Expence, setExpence] = useState(0);
  // const [CreditOut, setCreditOut] = useState(0);
  // const [Take, setTake] = useState(0);
  // const [CashClose, setCashClose] = useState(0);
  // const [CashText, setCashText] = useState('');
  // const [OldBills, setOldBills] = useState(0);
  // const [AdvUsed, setAdvUsed] = useState(0);
  // const [CreditINTxt, setCreditINTxt] = useState('');
  const [AdvanceTxt, setAdvanceTxt] = useState('');
  // const [PurchaseTxt, setPurchaseTxt] = useState('');
  // const [AdvanceUsedTxt, setAdvanceUsedTxt] = useState('');
  // const [CreditOutTxt, setCreditOutTxt] = useState('');

  const [SaveStatus, setSaveStatus] = useState(0);
  const [show, setShow] = useState(false);

  const refAdvanceUsedTxt = useRef();
  // const refCreditOutTxt = useRef();
  // const refCreditINTxt = useRef();
  const refAdvanceTxt = useRef();
  // const refAdvanceUsedTxt = useRef();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Resetcontrol = (e) => {
    e.current.style.border = "none";
  }




  // const [advanceList, setadvanceList] = useState([]);



  const insertToDB = async (SaveStatus) => {
    const response = {
      InsertDate: current,
      TRAN_ID: props.trid,
      Amount: Advance,
      GivenBy: AdvanceTxt,
    };
    const data = DailyAccountUpdateData(response);
    const res = await InsertDailyAdvance(data);
    const result = res.data;
    if (Number(result.Status) === 100) {
      handleCloseModal(false);
      alert(result.StatusMessage);
      ClearAccountsData();
      props.updateDashboard(props.id);
    }
    else if (Number(result.Status) === -100) {
      handleCloseModal(false);
      alert('(-ve) acount. \nInserted Successfully!');
      ClearAccountsData();
      props.updateDashboard(props.id);
    }
    else if (Number(result.Status) === 200) {
      handleCloseModal(false);
      alert('(+ve) acount. \nInserted Successfully!');
      ClearAccountsData();
      props.updateDashboard(props.id);
    }
    else {
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to save?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!'
      }).then((result) => {
        if (result.isConfirmed) {
          InsertAdvancessData(1);
        }
      });
    }

    // Save it!
    // fetch(`${variables.API_URL}DailyAccounts/InsertDailyAdvance`, {
    //   method: 'POST',
    //   headers: {
    //     'Accept': 'application/json',
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     InsertDate: current,
    //     TRAN_ID: props.trid,
    //     Amount: Advance,
    //     GivenBy: AdvanceTxt,
    //   })
    // })
    //   .then(res => {
    //     return res.json();
    //   })
    //   .then((result) => {

    //     if (result.interactID === 100) {
    //       handleCloseModal(false);
    //       alert(result.message);
    //       ClearAccountsData();
    //       props.updateDashboard(props.id);
    //     }
    //     else if (result.interactID === -100) {
    //       handleCloseModal(false);
    //       alert('(-ve) acount. \nInserted Successfully!');
    //       ClearAccountsData();
    //       props.updateDashboard(props.id);
    //     }
    //     else if (result.interactID === 200) {
    //       handleCloseModal(false);
    //       alert('(+ve) acount. \nInserted Successfully!');
    //       ClearAccountsData();
    //       props.updateDashboard(props.id);
    //     }
    //     else {

    //       if (window.confirm(result.message)) {
    //         // Save it!
    //         console.log('Save any way on -ve or +ve');
    //         InsertAdvancessData(1);
    //       } else {
    //         // Do nothing!
    //         console.log('Opt to crosscheck');
    //       }
    //       // alert(result.message);
    //       console.log('');
    //     }
    //     // alert('Account Saved!');
    //     //* alert(props.id);

    //   }, (error) => {
    //     alert(error);
    //   });

  }
  const InsertAdvancessData = (SaveStatus) => {
    setShow(true);
    if (Advance > 0 && AdvanceTxt.trim() === "") {
      refAdvanceTxt.current.style.border = "2px solid #fd9797";
      alert("\"Please enter \"Advance's description\"! ");
      return;
    }
    if (SaveStatus === 1) {
      insertToDB(SaveStatus);
    }
    else {
      Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to save?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Save it!'
      }).then((result) => {
        if (result.isConfirmed) {
          insertToDB(0);
        }
      });
    }
  };

  const ClearAccountsData = () => {
    settrid(0);
    // setTotaBillSales(0);
    // setOPCash(0);
    // setTotaBillSales(0);
    // setTotaNonBillSales(0);
    // setCreditIN(0);
    setAdvance(0);
    // setCashIn(0);
    // setPurchaseCashPayment(0);
    // setGPay(0);
    // setCardPay(0);
    // setExpence(0);
    // setCreditOut(0);
    // setTake(0);
    //  setCashClose(0);
    // setCashText(0);
    // setOldBills(0);
    // setAdvUsed(0);
    // setCreditINTxt('');
    setAdvanceTxt('');
    // setPurchaseTxt('');
    // setAdvanceUsedTxt('');
    // setCreditOutTxt('');
  };

  const handleCloseModal = (st) => {
    setShow(st)
  }

  return (
    <>
      {props.hide ? (
        <Tooltip title={props.advancetxt} followCursor>
          {
            (props.advance === 0 && '0') ||
            <Badge color="warning" variant="dot">{props.advance}</Badge>
          }
        </Tooltip>
      ) : (
        <Button size="small" className='sml' onClick={handleShow} startIcon={<Iconify icon="eva:plus-fill" />}>
          {<Tooltip title={props.advancetxt} followCursor>
            {
              (props.advance === 0 && '0') ||
              <Badge color="warning" variant="dot">{props.advance}</Badge>
            }
          </Tooltip>}
        </Button>
      )}
      {/*
      <button onClick={handleShow}  className="css-12vebo6-MuiButtonBase-root-MuiButton-root block m-2 bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded">
        Update
  </button> */}


      <Modal style={{ zIndex: 1100 }}
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Advance on -[{datee}]</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id='InserAccountsPopup' name='Edwit' onSubmit={(e) => {
            e.preventDefault();
            // console.log('Form Submited');
            InsertAdvancessData(0);
            // console.log(props.id, name, role);

            // console.log(' after');

          }}>

            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead />
                <TableBody>
                  <TableRow>



                    <TableCell component="th" scope="row">
                      <TextField variant="standard" type="number" size="small" name="adv" label="Advance Cash ₹ "
                        value={Advance}
                        onChange={(e) => { setAdvance(e.target.value) }} />
                    </TableCell>
                    <TableCell align="right">
                      <TextField variant="standard"
                        ref={refAdvanceTxt} size="small" fullWidth name="advd" label="Advance Desc.."
                        value={AdvanceTxt}
                        onFocus={(e) => { Resetcontrol(refAdvanceTxt) }}
                        onChange={(e) => { setAdvanceTxt(e.target.value) }} />
                    </TableCell>

                  </TableRow>

                </TableBody>
                <TableFooter />
              </Table>
            </TableContainer>

            <TextField variant="standard" multiline fullWidth size="small" label="Advance Cash ₹ "
              value={props.dailyAdvTrans}
            />

          </form>
        </Modal.Body>
        <Modal.Footer>

          <button onClick={handleClose} className="css-12vebo6-MuiButtonBase-root-MuiButton-root font-bold py-2 px-4">
            Close
          </button>

          <button onClick={handleClose} form='InserAccountsPopup' className="bt-green css-12vebo6-MuiButtonBase-root-MuiButton-root font-bold py-2 px-4">
            Add Advance
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default InsertAdvancessPopup;